import React, { FC, useEffect, useState } from "react";
import { IAdminGlobalData } from "@interfaces/screens/admin-data.interface";
import { AdminGlobalPresenter } from "@presenters/screens/admin-global.presenter";
import { Container, Row, Col } from "reactstrap";
import { AEATabs, AEATab } from "@components/";
import List from "devextreme-react/list";
import styles from "./global-admin.module.scss";

const GlobalAdmin: FC<any> = () => {
  const [data, setData] = useState(null);

  const view: IAdminGlobalData = {
    state: {
      data: data,
      setData: setData,
    },
  };
  const presenter = new AdminGlobalPresenter(view);

  useEffect(() => {
    presenter.initialize();
  }, []);

    const renderTabs = () => {
        return data != null ? 
            <Container fluid={false}>
                <Row xs="1" sm="2" md="2" lg="2" xl="2" xxl="3">
                {data.apps.map((app:any, index:number) => {
                    const active = index == 0;
                    return (                                                
                        <div  className={styles.listContainer}>
                            <h4>{app.Title}</h4>
                            <List {...presenter.getAdminListByApp(app.Id)} groupRender={groupRender} itemRender={itemRender}/>
                        </div>                        
                    )
                })}
                </Row>
            </Container>
        :<div></div>
    }

  const groupRender = (item: any) => {
    return <div>{item.key}</div>;
  };

    const itemRender = (item:any) => {
        return(
            <div >
                <a className={styles.itemList} href={item.OCTAVIAUrl} target="_blank">
                    <label>{item.Title}</label>
                    <i className="dx-icon-arrowright dx-icon-custom-style"></i>
                </a>
            </div>
        )
    }

  return renderTabs();
};

export default GlobalAdmin;
